



















import { defineComponent, PropType } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { getProfileUrl } from "@/lib/urlHelpers";
import { resolveUserName } from "@/lib/userHelpers";
import BaseAvatar from "@/components/BaseAvatar";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "FeedParticipants",
  components: { BaseAvatar, BaseButton, BaseConfirm },
  props: {
    show: { type: Boolean, required: true },
    participants: { type: Array as PropType<UserPublicData[]>, required: true },
  },
  setup() {
    return { getProfileUrl, resolveUserName };
  },
});
